/*
  Announcement bar carousel.
  Cross-fades between slides, pauses on hover/focus, respects reduced motion.
*/
if (!customElements.get('brand-announcement')) {
  customElements.define(
    'brand-announcement',
    class BrandAnnouncement extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.brand-announcement__slide'));
        if (this.slides.length < 2) return;

        this.index = 0;
        this.timer = null;
        this.autoplayDelay = parseInt(this.dataset.autoplay, 10) || 0;

        this.querySelector('.brand-announcement__arrow--prev')?.addEventListener('click', () => {
          this.go(this.index - 1);
          this.restart();
        });
        this.querySelector('.brand-announcement__arrow--next')?.addEventListener('click', () => {
          this.go(this.index + 1);
          this.restart();
        });

        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());

        this.start();
      }

      disconnectedCallback() {
        this.stop();
      }

      go(next) {
        const total = this.slides.length;
        const target = ((next % total) + total) % total;

        this.slides[this.index].classList.remove('is-active');
        this.slides[this.index].setAttribute('aria-hidden', 'true');
        this.slides[target].classList.add('is-active');
        this.slides[target].removeAttribute('aria-hidden');

        this.index = target;
      }

      start() {
        if (!this.autoplayDelay) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.stop();
        this.timer = setInterval(() => this.go(this.index + 1), this.autoplayDelay);
      }

      stop() {
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
      }

      restart() {
        this.stop();
        this.start();
      }
    }
  );
}
